// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"eedcec8e","455":"a61fa001","977":"d1ce1cad"}[chunkId] + ".chunk.js";
};